import PdfIcon from "@/assets/images/icons/pdf_red.svg?inline";
import PdfDownloadIcon from "@/assets/images/icons/pdf_download.svg?inline";

export default {
  name: "recommended-homes",

  data() {
    return {};
  },

  props: ["recommendedHomes"],

  mounted: function() {},

  computed: {},

  methods: {},

  watch: {},

  components: {
    PdfIcon,
    PdfDownloadIcon
  }
};
